<template>
  <div id="search_bar" v-click-outside="hideSearchModal" :class="'search_container' + (isSearchPage ? ' search_webpage' : '') + ((shortView && !showModal) ? ' short_view' : '')" @mouseover="expandSearch()" @mouseleave="collapseSearch()" @click="showSearchModal">
    <div class="bar">
      <filter-bar v-if="!isSearchPage" :on-filter="handleFilter" />
      <search-bar :on-search="handleSearch" :on-autofill-event="handleAutofillEvent" :on-auto-search="handleAutoSearch" />
    </div>
    <div v-show="showModal" v-if="!isSearchPage" class="search_dropdown">
      <div class="results">
        <template v-if="showAutofillEvent">
          <div v-if="tournamentsAutofill.length > 0" class="tournament_results">
            <div v-for="(tournament, index) in tournamentsAutofill" :key="'tournament_autofill_' + index">
              <tournament-card v-if="parseInt(index) < 4" :tournament="tournament" />
            </div>
          </div>
        </template>
        <template v-else>
          <img v-if="showLoading" class="loading_img" :src="contentCloudFrontWithVersion('/ellipsis.svg')" style="display: block; margin: 0 auto; width: 100px">
          <template v-else>
            <div v-if="showNoResults" class="search_notice"><i>No Results!</i></div>
            <template v-else>
              <div v-if="tournaments.length > 0" class="tournament_results">
                <div v-for="(tournament, index) in tournaments" :key="'tournament_' + index">
                  <tournament-card :tournament="tournament" />
                </div>
              </div>
              <div v-if="news.length > 0" class="newsletter_results">
                <div v-for="(n, index) in news" :key="'news_' + index" class="news-card">
                  <news-card :news="n" />
                </div>
              </div>
              <div v-if="hubs.length > 0" class="hub_results">
                <div v-for="(hub, index) in hubs" :key="'hubs_' + index" class="hub-card">
                  <hub-card :hub="hub" />
                </div>
              </div>
            </template>
          </template>
        </template>
      </div>
      <div v-if="(tournaments.length > 0 || news.length > 0 || hubs.length > 0) && (!showAutofillEvent)" class="more_results">
        <a class="btn_view_more_result" :href="routeSearchPage()">View more Results</a>
      </div>
    </div>
  </div>
</template>

<script>
import { component } from '../../mixins/component';
import _debounce from 'lodash/debounce';
import TournamentCard from './tournament-card';
import NewsCard from './news-card';
import HubCard from './hub-card';
import SearchBar from './search-bar';
import FilterBar from './filter-bar';
import ClickOutside from 'vue-click-outside';
import { EventBus, TOGGLE_SEARCH_BAR } from '../../event-bus';

export default {
  components: { SearchBar, FilterBar, TournamentCard, NewsCard, HubCard },
  directives: {
    ClickOutside,
  },
  mixins: [component],
  data() {
    return {
      shortView: true,
      keySearch: '',
      showLoading: false,
      allowNextRequest: true,
      showNoResults: false,
      showSearchDropdown: true,
      showAutofillEvent: false,
      tournamentsAutofill: [],
      tournaments: [],
      hubs: [],
      news: [],
      users: [],
      tournamentFeatured: 1,
      tournamentType: [],
      tournamentPlatform: [],
      hubType: ['all', 'highschool', 'college'],
      enabledNewsFilter: true,
      showModal: false,
    };
  },
  computed: {
    isSearchPage() {
      if (window.location.href.includes(this.appConfig.baseUrl + '/search')) {
        return true;
      }
      return false;
    },
  },
  created() {
    // this.handleClickOutside();
    // this.getListFeaturedEvent();
    this.handleAutoSearch = _debounce(this.handleSearch, 1000);
  },
  methods: {
    hideSearchModal() {
      if (this.showModal) {
        this.showModal = false;
        if (this.shortView) {
          setTimeout(function() {
            EventBus.$emit(TOGGLE_SEARCH_BAR, 'collapse');
          }, 510);
        }
        if (!this.isSearchPage) {
          document.getElementById('website_content').style = 'opacity: 1;';
          this.enableScrollPage();
        }
      }
    },
    showSearchModal() {
      this.showModal = true;
      setTimeout(function() {
        EventBus.$emit(TOGGLE_SEARCH_BAR, 'expand');
      }, 510);

      if (!this.isSearchPage) {
        document.getElementById('website_content').style = 'opacity: .5;';
        this.disableScrollPage();
      }
    },
    expandSearch() {
      this.shortView = false;
      setTimeout(function() {
        EventBus.$emit(TOGGLE_SEARCH_BAR, 'expand');
      }, 510);
    },
    collapseSearch() {
      this.shortView = true;
      if (!this.showModal) {
        setTimeout(function() {
          EventBus.$emit(TOGGLE_SEARCH_BAR, 'collapse');
        }, 510);
      }
    },
    handleSearch(keySearch) {
      if (!this.allowNextRequest) {
        return;
      }
      this.allowNextRequest = false;
      this.keySearch = keySearch;
      if (!this.keySearch) {
        this.showAutofillEvent = true;
        this.allowNextRequest = true;
        return;
      }
      this.tournaments = [];
      this.hubs = [];
      this.users = [];
      this.news = [];
      this.showLoading = true;
      this.showNoResults = false;
      this.showAutofillEvent = false;
      this.$http.get('/handle-search', {
        params: {
          'query': keySearch,
          'featured': this.tournamentFeatured,
          'tournament_type': JSON.stringify(this.tournamentType),
          'platform': JSON.stringify(this.tournamentPlatform),
          'hub_type': JSON.stringify(this.hubType),
          'news_filter': this.enabledNewsFilter ? 1 : 0,
        },
      })
        .then(response => {
          this.showLoading = false;
          this.allowNextRequest = true;
          var result = response.data.result;
          this.tournaments = result.tournaments;
          this.hubs = result.hubs;
          this.users = result.users;
          this.news = result.newsletters;
          if (Object.keys(this.tournaments).length === 0 && Object.keys(this.hubs).length === 0 && Object.keys(this.news).length === 0) {
            this.showNoResults = true;
          }
        })
        .catch(error => {
          console.log('search error request');
          console.log(error);
        })
        .finally(() => {
          this.showLoading = false;
          this.allowNextRequest = true;
        });
    },
    handleFilter(type, filterData) {
      if (type === 'event') {
        this.tournamentFeatured = filterData.featured ? 1 : 0;
        this.tournamentType = [];
        Object.keys(filterData.tournament_type).forEach(i => {
          if (filterData.tournament_type[i]) {
            this.tournamentType.push(i);
          }
        });
        this.tournamentPlatform = [];
        Object.keys(filterData.platform).forEach(i => {
          if (filterData.platform[i]) {
            this.tournamentPlatform.push(i);
          }
        });
        if (this.keySearch) {
          this.handleSearch(this.keySearch);
        }
      } else if (type === 'hub') {
        this.hubType = [];
        Object.keys(filterData).forEach(i => {
          if (filterData[i]) {
            this.hubType.push(i);
          }
        });
        if (this.keySearch) {
          this.handleSearch(this.keySearch);
        }
      } else if (type === 'news') {
        this.enabledNewsFilter = filterData ? 1 : 0;
        if (this.keySearch) {
          this.handleSearch(this.keySearch);
        }
      }
    },
    handleClickOutside() {
      const that = this;
      window.addEventListener('click', function(e){
        if (document.getElementById('search_bar').contains(e.target)){
          that.showSearchDropdown = true;
        } else {
          that.showSearchDropdown = false;
        }
      });
    },
    routeSearchPage() {
      var enableNewsFilter = this.enabledNewsFilter ? 1 : 0;
      var route = this.appConfig.baseUrl + '/search?query=' + this.keySearch + '&featured=' + this.tournamentFeatured + '&news_filter=' + enableNewsFilter;
      if (this.tournamentType.length > 0) {
        route += '&tournament_type=' + JSON.stringify(this.tournamentType);
      }
      if (this.tournamentPlatform.length > 0) {
        route += '&platform=' + JSON.stringify(this.tournamentPlatform);
      }
      if (this.hubType.length > 0) {
        route += '&hub_type=' + JSON.stringify(this.hubType);
      }
      return route;
    },
    async getListFeaturedEvent() {
      const timezone = encodeURIComponent(this.guessTimezone());
      const url = this.routeFilterEventV2() + '&category=featured' + '&search_autofill=1' + '&limit=3' + '&see_all=' + 0 + '&timezone=' + timezone;
      try {
        const res = await this.$http.get(url);
        this.tournamentsAutofill = res.data.content;
        this.showAutofillEvent = true;
      } catch (error) {
        console.log(error);
      }
    },
    handleAutofillEvent() {
      if (Object.keys(this.tournamentsAutofill).length === 0) {
        this.getListFeaturedEvent();
      } else {
        this.showAutofillEvent = true;
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../styles/search/search.css';
</style>
